import React, { useState, useEffect } from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const SocialPostInput = ({ 
  value, 
  onChange, 
  error 
}) => {
  const [platform, setPlatform] = useState(null);
  const [isValidUrl, setIsValidUrl] = useState(false);

  const platformPatterns = {
    instagram: /instagram\.com/i,
    tiktok: /tiktok\.com/i,
    youtube: /youtube\.com|youtu\.be/i,
    twitter: /twitter\.com|x\.com/i
  };

  const platformIcons = {
    instagram: 'Instagram',
    tiktok: 'Video',
    youtube: 'Youtube',
    twitter: 'Twitter'
  };

  useEffect(() => {
    if (value) {
      let detectedPlatform = null;
      let valid = false;

      for (const [key, pattern] of Object.entries(platformPatterns)) {
        if (pattern?.test(value)) {
          detectedPlatform = key;
          valid = true;
          break;
        }
      }

      setPlatform(detectedPlatform);
      setIsValidUrl(valid);
    } else {
      setPlatform(null);
      setIsValidUrl(false);
    }
  }, [value]);

  return (
    <div className="space-y-4">
      <Input
        label="Social Media Post URL"
        type="url"
        placeholder="https://instagram.com/p/..."
        value={value}
        onChange={(e) => onChange(e?.target?.value)}
        error={error}
        required
        description="Link to your post featuring this purchase"
      />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {Object.entries(platformIcons)?.map(([key, iconName]) => (
          <div
            key={key}
            className={`flex items-center gap-2 p-3 rounded-lg border transition-all ${
              platform === key
                ? 'border-primary bg-primary/10' :'border-border bg-muted/30'
            }`}
          >
            <Icon 
              name={iconName} 
              size={18} 
              color={platform === key ? 'var(--color-primary)' : 'var(--color-muted-foreground)'} 
            />
            <span className={`text-xs md:text-sm font-medium capitalize ${
              platform === key ? 'text-primary' : 'text-muted-foreground'
            }`}>
              {key}
            </span>
          </div>
        ))}
      </div>
      {value && isValidUrl && platform && (
        <div className="bg-success/10 rounded-lg p-4 border border-success/20">
          <div className="flex items-center gap-2">
            <Icon name="CheckCircle" size={18} color="var(--color-success)" />
            <p className="text-xs md:text-sm text-success font-medium">
              {platform?.charAt(0)?.toUpperCase() + platform?.slice(1)} post detected
            </p>
          </div>
        </div>
      )}
      {value && !isValidUrl && (
        <div className="bg-warning/10 rounded-lg p-4 border border-warning/20">
          <div className="flex items-start gap-2">
            <Icon name="AlertCircle" size={18} color="var(--color-warning)" className="flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-xs md:text-sm text-warning font-medium mb-1">
                Platform not recognized
              </p>
              <p className="text-xs text-warning/80">
                Please ensure the URL is from Instagram, TikTok, YouTube, or Twitter
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SocialPostInput;